import { render, staticRenderFns } from "./RegionalManager.vue?vue&type=template&id=9f585304&"
import script from "./RegionalManager.vue?vue&type=script&lang=js&"
export * from "./RegionalManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports